/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiBatchHistory.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-batch-history";

export class AutogenModelEdiBatchHistory<RowType extends ModelRow> extends Endpoint<RowType, RowEdiBatchHistoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiBatchHistory extends ModelRow<RowEdiBatchHistoryFields> {
	constructor(values?: Partial<RowEdiBatchHistoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiBatchHistoryFields {
	"edi_batch_history.batch": number;
	"edi_batch_history.company_id": string;
	"edi_batch_history.create_date": Date;
	"edi_batch_history.id": string;
	"edi_batch_history.trans_count": number;
	"edi_batch_history.transaction_id": string;
	"edi_batch_history.transaction_type": string;
	"edi_log.as2_msg_id": string;
	"edi_log.batch": number;
	"edi_log.company_id": string;
	"edi_log.create_date": Date;
	"edi_log.descr": string;
	"edi_log.direction": string;
	"edi_log.directory_local": string;
	"edi_log.edi_comm_id": number;
	"edi_log.file_local_dir": string;
	"edi_log.filename": string;
	"edi_log.func_batch": number;
	"edi_log.func_receiver_id": string;
	"edi_log.func_sender_id": string;
	"edi_log.func_version": string;
	"edi_log.id": string;
	"edi_log.interchange_id": number;
	"edi_log.intercompany": string;
	"edi_log.internal_filename": string;
	"edi_log.message_id": string;
	"edi_log.message_timestamp": number;
	"edi_log.orig_profile_id": string;
	"edi_log.orig_trans_type": string;
	"edi_log.partner_company": string;
	"edi_log.receiver_id": string;
	"edi_log.sender_id": string;
	"edi_log.set_control_no": number;
	"edi_log.status": string;
	"edi_log.template_id": number;
	"edi_log.total_func_grps": number;
	"edi_log.transaction_type": string;
	"edi_log.version": string;
	"edi_log.was_successful": string;
}

